// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
    }
};
// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml': '<div id="{{itemHandle}}" class="grid__item grid-product ' + bcSfFilterConfig.custom.grid_item_width + ' {{itemQuickShopClass}}" data-aos="row-of-' + bcSfFilterConfig.custom.products_per_row + '">' +
                                '<div class="grid-product__content">' +
                                    '{{itemSaleLabel}}' +
                                    '{{itemSoldOutLabel}}' +
                                    '{{itemQuickShopButton}}' +
                                    '<a href="{{itemUrl}}" class="grid-product__link {{itemSoldOutClass}}">' +
                                        '<div class="grid-product__image-mask">{{itemImages}}</div>' +
                                        '<div class="grid-product__meta">' +
                                            '<div class="grid-product__title">{{itemTitle}}</div>' +
                                            '{{itemVendor}}' +
                                            '<div class="grid-product__price">{{itemPrice}}</div>' +
                                        '</div>' +
                                    '</a>' +
                                    '{{itemColorSwatch}}' +
                                '</div>' +
                                '<div id="QuickShopModal-{{itemId}}" class="modal modal--square" data-product-id="{{itemId}}"></div>' +
                            '</div>',
    // Pagination Template
    'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></a></span>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></a></span>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="deco">...</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
    // Sorting Template
    'sortingHtml': '<label class="hidden-label">' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select>',
};
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) {
            return e.id == getParam('variant');
        });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
    // Get Image size
    var imgSize = '450x650';
    switch (bcSfFilterConfig.custom.products_per_row) {
        case 5:
            imgSize = '350x550';
            break;
        case 4:
            imgSize = '450x650';
            break;
        case 3:
            imgSize = '450x650';
            break;
        case 2:
            imgSize = '850x1050';
            break;
        case 1:
            imgSize = '1400x1800';
            break;
    }
    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : '';
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], imgSize) : bcSfFilterConfig.general.no_image_url;
    var itemImagesHtml = '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">' +
                            '<img src="' + itemThumbUrl + '" alt="{{itemTitle}}" class="grid-product__image lazyloaded">' +
                          '</div>';
    if (!soldOut) {
        if (bcSfFilterConfig.custom.product_hover_image && images.length > 1) {
            var itemFlipImageUrl = this.optimizeImage(images[1]['src'], imgSize);
            itemImagesHtml += '<div class="grid-product__secondary-image" style="background-image: url(' + itemFlipImageUrl + ')"></div>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
        itemPriceHtml += '<span class="grid-product__price--original">' + this.formatMoney(data.compare_at_price_min) + '</span>';
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.sale_price + '</span>';
    }
    if (priceVaries) {
        itemPriceHtml += bcSfFilterConfig.label.from_text_html.replace(/{{ price }}/g, this.formatMoney(data.price_min));
    } else {
        itemPriceHtml += this.formatMoney(data.price_min);
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    // Add soldOut class
    var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);
    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? '<div class="grid-product__tag">' + bcSfFilterConfig.label.sold_out + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);
    // Add onSale Label
    var itemSaleLabelHtml = '';
    if (onSale && !soldOut) {
        var savePrice = this.formatMoney(data.compare_at_price_min - data.price_min);
        itemSaleLabelHtml = '<div class="grid-product__tag">' + bcSfFilterConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice) + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
    // Add Quick shop
    var itemQuickShopClass = '';
    var itemQuickShopButtonHtml = '';
    if (bcSfFilterConfig.custom.quick_shop_enable && !soldOut) {
        itemQuickShopClass = 'grid-product__has-quick-shop';
        itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide" data-product-id="{{itemId}}">' +
                                      '<span class="quick-product__label">' + bcSfFilterConfig.label.quick_shop + '</span>' +
                                  '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);
    // Build content for Modal
    if (!this.isMobile() && bcSfFilterConfig.custom.quick_shop_enable) {
        var quickUrl = this.buildProductItemUrl(data) + '?view=quickview';
        jQ.ajax({
            url: quickUrl,
            success: function(result) {
                jQ('#QuickShopModal-' + data.id).html(result);
                if (index == totalProduct) {
                    theme.initQuickShop();
                    AOS.init({
                        easing: 'ease-out-quad',
                        once: true
                    });
                    window.sections = new theme.Sections();
                    sections.register('product', theme.Product);
                    sections.register('product-template', theme.Product);
                    sections.register('collection-template', theme.Collection);
                }
            }
        });
    }

    // Add Swatch
    var itemSwatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemColorSwatch}}/g, itemSwatchHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
    return itemHtml;
};
// Build Swatch
function buildSwatch(data, ob) {
    var _this = ob;
    var itemSwatchHtml = '';
    if (bcSfFilterConfig.custom.collection_color_swatches) {
        var swatch_file_extension = 'png';
        data.options_with_values.forEach(function(option, index) {
            var option_name = option.name.toLowerCase();
            if (option_name.indexOf('color') !=- 1 || option_name.indexOf('colour') !=-1) {
                var option_index = index;
                var values = '';
                itemSwatchHtml += '<div class="grid-product__colors">';
                data.variants.forEach(function(variant) {
                    var temp = variant.merged_options[option_index].split(':');
                    var value = temp[1];
                    if ( values.indexOf(value) == -1 ) {
                        values = values + ',' + value;
                        values = values.split(',');
                        var color_image = _this.optimizeImage(variant.image, '50px');
                        var color_swatch_fallback = value;
                        itemSwatchHtml += '<a  href="' + _this.buildProductItemUrl(data) + '" class="color-swatch" style="background-image: url(' + color_image + '); background-color: ' + color_swatch_fallback + '"></a> ';
                    }
                });
                itemSwatchHtml += '</div>';
            }
        });
    }
    return itemSwatchHtml;
}
/************************** END BUILD PRODUCT LIST **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.pagination).html('');
            return false;
        }
        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;
            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
               beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            jQ(this.selector.pagination).html(paginationHtml);
        }
    }
};
/************************** BUILD TOOLBAR **************************/
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');
        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);
            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};
/************************** END BUILD TOOLBAR **************************/
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    // if (bcSfFilterConfig.custom.quick_shop_enable) {
        // window.sections = new theme.Sections();
        // sections.register('product', theme.Product);
        // sections.register('collection-template', theme.Collection);
        // theme.Product.prototype.createImageCarousels = function() {
        //   // Init zoom on non-lazy loaded image
        //   if (this.settings.zoom) {
        //     this.initZoom($('.photo-zoom-link__initial'));
        //   }
        //   if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
        //     // Single product image. Init video if it exists
        //     var $video = $('.product-image-main').find('.product__video');
        //     if ($video.length) {
        //       this.initVideo($video);
        //     }
        //     return;
        //   }
        //   this.settings.hasMultipleImages = true;
        //   // Set starting slide (for both sliders)
        //   var $activeSlide = this.$mainSlider.find('.starting-slide');
        //   var startIndex = this._slideIndex($activeSlide);
        //   // Lame way to prevent duplicate event listeners
        //   this.$mainSlider.off('init');
        //   this.$mainSlider.off('beforeChange');
        //   this.$mainSlider.on('init', this.mainSlideInit.bind(this));
        //   this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
        //   var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;
        //   var self = this;
        //   this.$mainSlider.not('.slick-initialized').slick({
        //     adaptiveHeight: thumbnailsVertical ? false : true,
        //     asNavFor: self.$thumbSlider,
        //     infinite: false,
        //     arrows: false,
        //     dots: false,
        //     initialSlide: startIndex
        //   });
        //   this.$thumbSlider.not('.slick-initialized').slick({
        //     asNavFor: self.$mainSlider,
        //     slidesToShow: thumbnailsVertical ? 3 : 5,
        //     slidesToScroll: 1,
        //     arrows: false,
        //     dots: false,
        //     vertical: thumbnailsVertical,
        //     verticalSwiping: thumbnailsVertical,
        //     focusOnSelect: true,
        //     infinite: false,
        //     customHeightMatching: thumbnailsVertical,
        //     customSlideAdvancement: true,
        //     initialSlide: startIndex
        //   });
          // Too many thumbnails can cause the AOS calculations to be off
          // so refresh that when the slider is ready
        //   if (AOS) {
        //     AOS.refresh();
        //   }
        //   this.settings.slickInitialized = true;
        // };
    // }
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
};


    // Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e);if(i!=this.selector.filterTree&&i!=this.selector.filterTreeHorizontal&&jQ(i).html(""),void 0===i)i="vertical"==t?this.selector.filterTree:this.selector.filterTreeHorizontal;void 0!==r&&"before"==r?jQ(i).prepend(e):jQ(i).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
